import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useSelector } from 'hooks/redux'
import {
  getSearchResource,
  getSearchResults,
} from 'selectors/deprecated/search'
import { setFilters } from 'actions/deprecated/search'
import { PagedTable } from 'components/chec'
import { classNames } from 'utils/utils'
import strings from 'utils/strings'
import SearchInput from './SearchInput'

const SearchV2 = ({
  className,
  SearchFilters,
  isSearching,
  columns,
  resource,
  searchUri,
  addToSearchRequestBody,
  searchFilterModules,
  batchImport,
}) => {
  const dispatch = useDispatch()

  const [appliedFilters, setAppliedFilters] = useState({})
  const [page, setPage] = useState(null)

  const { totalResults, loadingInitialResults, startIndex, searchString } =
    useSelector(getSearchResource, resource)

  const results = useSelector(getSearchResults, { resource })

  const showResults = useMemo(() => !isEmpty(results), [results])

  // reset pagingation
  useEffect(() => {
    if (showResults && startIndex === 1) {
      setPage(null)
    }
  }, [showResults, startIndex])

  return (
    <>
      {batchImport ? (
        <SearchFilters
          setFilters={(values) => dispatch(setFilters(values, resource))}
          applyFilters={(filters) => setAppliedFilters(filters)}
          isSearching={isSearching}
          searchString={searchString}
          batchImport={batchImport}
          searchFilterModules={searchFilterModules}
          resource={resource}
          searchUri={searchUri}
          page={page}
          setPage={setPage}
          appliedFilters={appliedFilters}
          addToSearchRequestBody={addToSearchRequestBody}
        />
      ) : (
        <>
          <SearchInput
            resource={resource}
            searchUri={searchUri}
            page={page}
            setPage={setPage}
            filters={appliedFilters}
            addToSearchRequestBody={addToSearchRequestBody}
            tooltip={strings.vehicle_search_explainer}
          />
          {SearchFilters && (
            <SearchFilters
              setFilters={(values) => dispatch(setFilters(values, resource))}
              applyFilters={(filters) => setAppliedFilters(filters)}
              isSearching={isSearching}
              searchString={searchString}
              searchFilterModules={searchFilterModules}
            />
          )}
        </>
      )}
      {showResults && (
        <PagedTable
          className={classNames(className, 'new-search')}
          columns={columns}
          isSearching={loadingInitialResults}
          dataSource={results}
          resource={resource}
          startIndex={startIndex}
          totalResults={totalResults}
          onPageChange={setPage}
          defaultTopMargin={12}
        />
      )}
    </>
  )
}

SearchV2.defaultProps = {}

SearchV2.propTypes = {
  /** Make sure to comment */
  /** Classname */
  SearchFilters: PropTypes.func,
  className: PropTypes.string,
  searchUri: PropTypes.string,
  columns: PropTypes.array,
  resource: PropTypes.string,
  isSearching: PropTypes.bool,
  addToSearchRequestBody: PropTypes.object,
  searchFilterModules: PropTypes.arrayOf(PropTypes.string),
  batchImport: PropTypes.bool,
}

export default SearchV2
